import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import FormSelection from "../components/FormSelection/FormSelection";
import ReadOnly from "../components/ReadOnly/ReadOnly";

const uuidv4 = require("uuid/v4");

export class AppRouter extends Component {
  constructor() {
    super();

    this.state = {
      selectedForm: {}
    };
  }

  handleFormSelection({ formData }, e) {
    // TODO: move formselection logic out of AppRouter
    const fD = { ...formData }; // Create a deep copy of formdata
    fD.formguid = uuidv4(); // Generate new guid (uuid/v4) //TODO: remove formguid
    this.setState({ selectedForm: fD }); // Save formdata to state // TODO: use redux
  }

  render() {
    return (
      <Router>
        {/* {this.state.selectedForm.formguid ? selectedFormComponent : formSelect} */}

        {/* TODO: remove sandbox before going to prod build */}

        <Route path="/readonly" exact component={ReadOnly} />
        <Route path="/" exact component={FormSelection} />
        {/* <Route path="/sandbox/" component={Sandbox} /> */}
        {/* <Route path="/" exact component={Claims} /> */}
      </Router>
    );
  }
}

export default AppRouter;
